import React from 'react';

import { useConsentModeEnabled } from 'app/components/consent-mode-select/GatedConsentModeSelect';

import ConsentModeSelect from '../ConsentModeSelect';

export default function GatedConsentModeSelect(props) {
  const { consentModeEnabled } = useConsentModeEnabled();

  // no fallback
  if (!consentModeEnabled) {
    return null;
  }

  return <ConsentModeSelect {...props} />;
}

GatedConsentModeSelect.propTypes = ConsentModeSelect.propTypes;
